import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Icon } from '@digsup/components-icon';
import { Wrapper } from './Wrapper';
import { styles } from './Avatar.scss';

const cx = classNames.bind(styles);

/**
 * System component
 ~~~js
 import { System } from '@digsup/components-avatar';
 ~~~
 */

export const System = ({ size, isInverted, className }) => {
  let iconSize = '';

  if (size === 'large') {
    iconSize = 'xlarge';
  } else {
    iconSize = 'medium';
  }

  const classes = cx(
    'c-avatar c-avatar--type-system',
    {
      [`c-avatar--${size}`]: size,
    },
    className,
  );

  return (
    <div className={classes}>
      <Wrapper
        backgroundHorizontalAlign="center"
        backgroundVerticalAlign="bottom">
        <Icon name={isInverted ? 'user-small' : 'user'} size={iconSize} />
      </Wrapper>
    </div>
  );
};

System.propTypes = {
  size: PropTypes.oneOf(['large', 'medium']),
  isInverted: PropTypes.bool,
  className: PropTypes.string,
};

System.defaultProps = {
  size: 'large',
  isInverted: false,
  className: '',
};
